import { PriorAuthorizationListItem } from './types'
import { formatApiDate } from '~/shared/lib/date'

export function asDate(inputDate: string | null | undefined) {
  const value = formatApiDate(inputDate, 'MMM. d, yyyy') ?? ''
  if (value.match(/invalid/i)) {
    return inputDate
  } else {
    return value
  }
}

export function getDeterminationDisplay(priorAuth: PriorAuthorizationListItem) {
  if (!priorAuth.determination) return 'Pending'
  const status = priorAuth.status ? ` (${priorAuth.status})` : ''
  return `${priorAuth.determination}${status}`
}

type Name = Pick<
  PriorAuthorizationListItem['providers'][number],
  'first_name' | 'middle_name' | 'last_name'
>

export function fullName(name: Name): string {
  return [name.first_name, name.middle_name, name.last_name].filter(part => !!part).join(' ')
}
